export const FORM = 'yF'
export const TABLE = 'yT'
